export default {
    ACTION_HANDLE_CREATE_IDEA_MODAL: 'ACTION_HANDLE_CREATE_IDEA_MODAL',
    ACTION_CREATE_IDEA: 'ACTION_CREATE_IDEA',
    ACTION_DELETE_IDEA: 'ACTION_DELETE_IDEA'
}